import { View } from '@react-pdf/renderer'

import { VatDeclarationsReport } from '@features/vatDeclarations/types/vatDeclarationsReport'

import { useFormattedReport } from '../../hooks/useFormattedReport'
import { ReportSection } from './elements'

interface ExportTablePdfProps {
  report: VatDeclarationsReport
  countryId?: string
  locale?: string
  currency?: string
}

export const ExportTablePdf = ({ report, countryId, locale, currency }: ExportTablePdfProps) => {
  const blocks = useFormattedReport(report, countryId)

  return (
    <View>
      {blocks.map((block, index) => (
        <ReportSection key={index} block={block} countryId={countryId} currency={currency} locale={locale} />
      ))}
    </View>
  )
}
